export var ValuationPropertyHeadingEnum;
(function (ValuationPropertyHeadingEnum) {
    ValuationPropertyHeadingEnum["Description"] = "Description";
    ValuationPropertyHeadingEnum["SgCode"] = "SG code";
    ValuationPropertyHeadingEnum["FarmNumber"] = "Farm number";
    ValuationPropertyHeadingEnum["ErfNumber"] = "Erf Number";
    ValuationPropertyHeadingEnum["UnitNumber"] = "Unit Number";
    ValuationPropertyHeadingEnum["Address"] = "Address";
    ValuationPropertyHeadingEnum["ErfSize"] = "Erf size";
})(ValuationPropertyHeadingEnum || (ValuationPropertyHeadingEnum = {}));
export const ValuationPropertyHeadingLookup = new Map([
    [ValuationPropertyHeadingEnum.Description, "description"],
    [ValuationPropertyHeadingEnum.SgCode, "sgCode"],
    [ValuationPropertyHeadingEnum.FarmNumber, "farmNumber"],
    [ValuationPropertyHeadingEnum.ErfNumber, "erfNumber"],
    [ValuationPropertyHeadingEnum.UnitNumber, "unitNumber"],
    [ValuationPropertyHeadingEnum.Address, "address"],
    [ValuationPropertyHeadingEnum.ErfSize, "erfSize"]
]);
export var ValuationAppealObjectionHeadingEnum;
(function (ValuationAppealObjectionHeadingEnum) {
    ValuationAppealObjectionHeadingEnum["Description"] = "Description";
    ValuationAppealObjectionHeadingEnum["SgCode"] = "SG code";
    ValuationAppealObjectionHeadingEnum["FarmNumber"] = "Farm number";
    ValuationAppealObjectionHeadingEnum["ErfNumber"] = "Erf Number";
    ValuationAppealObjectionHeadingEnum["UnitNumber"] = "Unit Number";
    ValuationAppealObjectionHeadingEnum["Address"] = "Address";
})(ValuationAppealObjectionHeadingEnum || (ValuationAppealObjectionHeadingEnum = {}));
export const ValuationAppealObjectionHeadingLookup = new Map([
    [ValuationAppealObjectionHeadingEnum.Description, "description"],
    [ValuationAppealObjectionHeadingEnum.SgCode, "sgCode"],
    [ValuationAppealObjectionHeadingEnum.FarmNumber, "farmNumber"],
    [ValuationAppealObjectionHeadingEnum.ErfNumber, "erfNumber"],
    [ValuationAppealObjectionHeadingEnum.UnitNumber, "unitNumber"],
    [ValuationAppealObjectionHeadingEnum.Address, "address"]
]);
